import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Image } from '@blueprint/image';

type ListingImageContainerProps = {
    isCompact: boolean;
};

export const ListingImageContainer = styled('div')<ListingImageContainerProps>(
    ({ theme: { colors, borderRadius }, isCompact }) => css`
        background: ${colors['graphic-background-accent']};
        display: block;
        overflow: hidden;
        position: relative;
        ${isCompact
            ? `
            height: 7.5em;
            width: 7.5em;
        `
            : `
            border-radius: ${borderRadius['300']};
            width: 100%;
            height: auto;
            padding-bottom: 66.5289256198%;
        `}

        ${Image} {
            display: block;
            height: 100%;
            object-fit: cover;
            object-position: center center;
            width: 100%;
        }

        img {
            bottom: 0;
            height: auto;
            left: 0;
            margin: auto;
            position: absolute;
            right: 0;
            top: 0;
            width: 32.1428571429%;
        }
    `
);
